/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { ReactNode } from 'react';
import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, Typography, Typography2, breakpoints } from '@coursera/cds-core';

import type { Asset } from 'bundles/unified-career-academy/types';

type Props = {
  title?: string | null;
  subtitle?: string | null;
  image?: Asset;
  description?: ReactNode;
};

const style = {
  wrapper: () => css`
    padding: var(--cds-spacing-800) 0;
  `,
  image: css`
    max-width: 550px;

    img {
      width: 100%;
    }
  `,
  content: () => css`
    max-width: 550px;

    ${breakpoints.down('sm')} {
      padding: var(--cds-spacing-400) var(--cds-spacing-150) 0;
    }
  `,
};

const AboutProfessionalCertsModule: React.FC<Props> = ({ title, subtitle, image, description }) => {
  if (!image?.url || !title) {
    return null;
  }

  return (
    <section css={style.wrapper}>
      <Grid item container xs={12} justifyContent="space-evenly" alignContent="center">
        <Grid item css={style.image}>
          <Imgix src={image.url} alt={image.description || ''} />
        </Grid>
        <Grid item container css={style.content}>
          <Grid item>
            <Typography2 variant="subtitleMedium" color="body" component="p">
              {subtitle}
            </Typography2>
            <Typography variant="h1" component="h2">
              {title}
            </Typography>
          </Grid>
          <Grid item>{description}</Grid>
        </Grid>
      </Grid>
    </section>
  );
};

export default AboutProfessionalCertsModule;
